<template>
  <div class="account-settings-info-view">
    <a-row :gutter="16">
      <a-form-model ref="form" :model="form" :rules="rules" v-if="form.id">
        <a-form-model-item label="区域" prop="regionId" v-if="role !== 1">
          <a-select
            show-search
            v-model="form.regionId"
            placeholder="请选择"
            option-filter-prop="children"
            :filter-option="filterOption"
          >
            <a-select-option v-for="d in userRegion" :key="d.id">{{ d.name }}</a-select-option>
          </a-select>
          <!-- <a-input v-model="form.name" placeholder="请输入" :maxLength="50" /> -->
        </a-form-model-item>
        <a-form-model-item :label="role == 1 ? '企业品牌' : '经销商名称'" prop="name">
          <a-input v-model="form.name" placeholder="请输入" :maxLength="50" />
        </a-form-model-item>
        <a-form-model-item label="简称" prop="referredName">
          <a-input v-model="form.referredName" placeholder="请输入" :maxLength="50" />
        </a-form-model-item>
        <a-form-model-item label="联系人" prop="contacts">
          <a-input v-model="form.contacts" placeholder="请输入" :maxLength="20" />
        </a-form-model-item>
        <a-form-model-item label="联系电话" prop="mobile">
          <a-input
            oninput="value=value.replace(/[^\d]/g,'')"
            v-model="form.mobile"
            placeholder="请输入"
            :maxLength="11"
          />
        </a-form-model-item>
        <a-form-model-item label="统一社会信用代码" prop="socialCreditCode">
          <a-input v-model="form.socialCreditCode" placeholder="请输入" disabled :maxLength="255" />
        </a-form-model-item>
        <a-form-model-item label="营业天" prop="businessDays">
          <a-select
            mode="multiple"
            style="width: 100%"
            placeholder="请选择"
            @change="handleChange"
            v-model="form.businessDays"
          >
            <a-select-option :value="1">周一</a-select-option>
            <a-select-option :value="2">周二</a-select-option>
            <a-select-option :value="3">周三</a-select-option>
            <a-select-option :value="4">周四</a-select-option>
            <a-select-option :value="5">周五</a-select-option>
            <a-select-option :value="6">周六</a-select-option>
            <a-select-option :value="7">周日</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="营业开始-结束" prop="customerMoblie">
          <a-time-picker
            v-model="form.startTimes"
            :disabled-hours="disabledHour"
            :disabled-minutes="disabledMinute"
            format="HH:mm"
            placeholder="选择开始时间"
            :allowClear="false"
            @change="handleTime($event, 1)"
          />
          ~
          <a-time-picker
            v-model="form.endTimes"
            :disabled-hours="disabledHours"
            :disabled-minutes="disabledMinutes"
            format="HH:mm"
            placeholder="选择结束时间"
            :allowClear="false"
            @change="handleTime($event, 2)"
          />
          <!-- <a-input v-model="form.customerMoblie" placeholder="请输入" :maxLength="255" /> -->
        </a-form-model-item>
        <a-form-model-item label="客服电话" prop="customerMoblie">
          <a-input v-model="form.customerMoblie" placeholder="请输入" :maxLength="15" />
        </a-form-model-item>
        <!-- <a-form-model-item label="开户卡号" prop="bankCode">
        <a-input v-model="form.bankCode" placeholder="请输入" :maxLength="255" />
      </a-form-model-item>
      <a-form-model-item label="开户银行" prop="bankName">
        <a-input v-model="form.bankName" placeholder="请输入" :maxLength="255" />
      </a-form-model-item> -->
        <a-form-model-item label="省市区" prop="area">
          <v-distpicker
            :province="form.province"
            :city="form.city"
            :area="form.area"
            @province="onChangeProvince"
            @city="onChangeCity"
            @area="onChangeArea"
          >
          </v-distpicker>
        </a-form-model-item>
        <a-form-model-item label="详细地址" prop="address">
          <a-input v-model="form.address" placeholder="请输入" type="textarea" allow-clear />
        </a-form-model-item>
        <a-form-model-item label="附件图片(营业执照/门牌照等)" prop="fileInfos">
          <file-upload
            type="image"
            @input="getImg($event, 'fileInfos')"
            :file="form.fileInfos"
            :count="6"
            autoCropHeight="350"
            autoCropWidth="750"
          ></file-upload>
          <a-input type="text" v-model="form.fileInfos" v-show="isShow"></a-input>
        </a-form-model-item>

        <template v-if="role == 1">
          <a-form-model-item label="评价" prop="evaluateOptions">
            <a-checkbox-group v-model="form.evaluateOptions" name="checkboxgroup" :options="evaluationOptions" />
          </a-form-model-item>
          <!-- <a-form-model-item label="全景图" prop="panoramaImg ">
            <file-upload
              type="image"
              @input="getImg($event, 'panoramaImg')"
              :file="form.panoramaImg"
              :count="1"
              autoCropHeight="350"
              :isUpload="false"
              autoCropWidth="750"
            ></file-upload>
          </a-form-model-item> -->
          <a-form-model-item label="背景图" prop="backdropImg ">
            <file-upload
              type="image"
              @input="getImg($event, 'backdropImg')"
              :file="form.backdropImg"
              :count="1"
              autoCropHeight="1334"
              autoCropWidth="750"
            ></file-upload>
          </a-form-model-item>
          <a-form-model-item label="公司logo" prop="logoImg">
            <file-upload
              type="image"
              @input="getImg($event, 'logoImg')"
              :file="form.logoImg"
              :count="1"
              autoCropHeight="200"
              autoCropWidth=""
            ></file-upload>
          </a-form-model-item>
          <a-form-model-item label="公司电子服务章" prop="stampImg">
            <file-upload
              type="image"
              :file="form.stampImg"
              @input="getImg($event, 'stampImg')"
              :count="1"
              autoCropHeight="200"
              autoCropWidth="200"
              :isUpload="false"
            ></file-upload>
          </a-form-model-item>
          <!-- <a-form-model-item label="质保承诺" prop="commitmentIntroduce">
            <a-input
              v-model="form.commitmentIntroduce"
              placeholder="请输入"
              type="textarea"
              allow-clear
              :maxLength="300"
            />
          </a-form-model-item> -->
          <a-form-model-item label="质保承诺" prop="serviceIntroduce">
            <a-input
              v-model="form.serviceIntroduce"
              placeholder="请输入"
              @change="handleCheng"
              type="textarea"
              allow-clear
            />
          </a-form-model-item>
          <a-form-model-item label="服务电话" prop="serviceMoblie">
            <a-input v-model="form.serviceMoblie" placeholder="请输入" :maxLength="255" />
          </a-form-model-item>
        </template>
        <a-form-model-item label="备注" prop="remark">
          <a-input v-model="form.remark" placeholder="请输入" type="textarea" allow-clear />
        </a-form-model-item>
        <div class="bottom-control">
          <a-space>
            <a-button type="primary" :loading="submitLoading" @click="submitForm"> 提交 </a-button>
            <!-- <a-button type="dashed" @click="cancel"> 取消 </a-button> -->
          </a-space>
        </div>
      </a-form-model>
    </a-row>

    <!-- <avatar-modal ref="modal" @ok="setavatar" /> -->
  </div>
</template>
  <script>
import AvatarModal from './AvatarModal'
import { getTenant, updateTenant } from '@/api/system/tenant'
import { getUserProfile, updateUserProfile } from '@/api/system/user'
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
  name: 'BaseSettings',
  components: {
    AvatarModal,
  },
  data() {
    const reg = /^1(3|4|5|6|7|8|9)\d{9}$/
    const validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入联系电话'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确的联系电话'))
      } else {
        callback()
      }
    }
    return {
      submitLoading: false,
      // cropper
      sexValue: {
        men: 1,
        women: 2,
      },
      userRegion: [],
      isShow: false,
      form: {
        id: undefined,
        address: undefined,
        area: undefined,
        bankCode: undefined,
        bankName: undefined,
        businessDays: undefined,
        city: undefined,
        commitmentIntroduce: undefined,
        contacts: undefined,
        customerMoblie: undefined,
        evaluateOptions: undefined,
        fileInfos: undefined,
        lat: undefined,
        log: undefined,
        logoImg: undefined,
        mobile: undefined,
        name: undefined,
        province: undefined,
        referredName: undefined,
        regionId: undefined,
        remark: undefined,
        serviceIntroduce: undefined,
        serviceMoblie: undefined,
        socialCreditCode: undefined,
        stampImg: undefined,
        code: undefined,
        startTime: 480,
        endTime: 1080,
        startTimes: moment('2024-10-22 08:00', 'YYYY-MM-DD HH:mm'),
        endTimes: moment('2024-10-22 18:00', 'YYYY-MM-DD HH:mm'),
      },
      role: 1,
      evaluationOptions: [
        { value: 1, label: '商品评价' },
        { value: 2, label: '店家服务态度' },
        { value: 3, label: '安装评价' },
        { value: 4, label: '验收评价' },
        { value: 5, label: '服务评价' },
        { value: 6, label: '回访评价' },
        { value: 7, label: '服务人员形象评价' },
        { value: 8, label: '对服务流程讲解' },
        { value: 9, label: '管路检查及丝堵检查' },
        { value: 10, label: '管道真伪查询' },
        { value: 11, label: '打压试验' },
        { value: 12, label: ' 检查管路漏水、虚焊、漏焊' },
        { value: 13, label: ' 是否张贴关闭总阀及温馨提示' },
        { value: 14, label: '拍摄全景管路图' },
      ],
      preview: {},
      option: {
        img: '',
        info: true,
        size: 1,
        outputType: 'jpeg',
        canScale: false,
        autoCrop: true,
        // 只有自动截图开启 宽度高度才生效
        autoCropWidth: 180,
        autoCropHeight: 180,
        fixedBox: true,
        // 开启宽度和高度比例
        fixed: true,
        fixedNumber: [1, 1],
      },
      rules: {
        name: [{ required: true, message: this.role === 1 ? '请输入企业品牌' : '请输入经销商名称', trigger: 'blur' }],
        referredName: [{ required: true, message: '请输入简称', trigger: 'blur' }],
        code: [{ required: true, message: '请输入信用编码', trigger: 'blur' }],
        socialCreditCode: [{ required: true, message: '请输入统一社会信用代码', trigger: 'blur' }],
        // serviceIntroduce: [{ required: true, message: '请输入服务承诺', trigger: 'blur' }],
        serviceMoblie: [{ required: true, message: '请输入服务电话', trigger: 'blur' }],
        logoImg: [{ required: true, message: '请上传公司logo', trigger: 'blur' }],
        customerMoblie: [{ required: true, message: '请输入客服电话', trigger: 'blur' }],
        evaluateOptions: [{ required: true, message: '请选择评价', trigger: 'blur' }],
        fileInfos: [{ required: true, message: '请上传附件信息', trigger: 'blur' }],
        mobile: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { validator: validatePhone, trigger: 'change' },
        ],
        commitmentIntroduce: [{ required: true, message: '请输入承诺保证', trigger: 'blur' }],
        address: [{ required: true, message: '请输入详情地址', trigger: 'blur' }],
        area: [{ required: true, message: '请选择地址', trigger: 'blur' }],
        businessDays: [{ required: true, message: '请选择营业天', trigger: 'blur' }],
        contacts: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
      },
    }
  },
  computed: {
    ...mapGetters(['nickname', 'avatar', 'userTentant']),
  },
  mounted() {
    this.role = this.userTentant.type
    console.log(this.role, '的点点滴滴弟弟妹妹')
    this.getUser()
  },
  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    handleCheng(e) {
      // console.log(e,e.target.value,'点点滴');
      this.form.commitmentIntroduce = e.target.value
      // this.$f
    },
    // 选择省
      onChangeProvince(e) {
      console.log(e, 'dddd点点滴')
      if (e.code) {
        this.form.province = e.value
      } else {
        this.form.province = ''
        this.form.city = ''
        this.form.area = ''
      }
    },
    /** 上传图片成功回调 */
    getImg(info, fieldName) {
      console.log('info5555', info)
      this.form[fieldName] = info
      this.$refs.form.clearValidate(fieldName)
    },
    // 选择市
       onChangeCity(e) {
      if (e.code) {
        this.queryParam.city = e.value
      } else {
        this.queryParam.city = ''
        this.queryParam.area = ''
      }
    },
    // 选择区
      onChangeArea(e) {
      if (e.code) {
        this.queryParam.area = e.value
      } else {
        this.queryParam.area = ''
      }
    },
    /** 提交按钮 */
    submitForm: function () {
      console.log(this.form, '对对对对对对')
       this.$refs.form.validate((valid, object) => {
        this.form.bankCode = '1'
        this.form.bankName = '1'
        if (valid) {
          this.submitLoading = true
          updateTenant(this.form)
            .then((response) => {
              this.$message.success('修改成功', 3)
              this.open = false
              this.$emit('ok')
              this.submitLoading = false
            })
            .catch(() => {
              this.submitLoading = false
            })
        } else {
          return false
        }
      })
    },
    getUser() {
      //   getUserProfile().then((response) => {
      //     this.user = response.data
      //     console.log(this.user, ' this.user this.user')

      //     this.roleGroup = response.roleGroup
      //     this.postGroup = response.postGroup
      //   })
      console.log(this.userTentant.tenantId, ' this.userTentant.tenantId===')
      getTenant(this.userTentant.tenantId).then((res) => {
        this.form = res.data
        const time = moment().startOf('day').unix()
        this.handleTime((time + res.data.startTime * 60) * 1000, 1)
        this.handleTime((time + res.data.endTime * 60) * 1000, 2)
        console.log(res, '的点点滴滴===')
      })
    },
    setavatar(url) {
      console.log(this.avatar)
      console.log(url)
      this.option.img = url
      this.user.avatar = url
    },
    // 禁用分钟
    disabledMinute(selectedHour) {
      if (this.hour && this.hour.length) {
        if (selectedHour === this.hour[0] - 1) {
          return this.minute
        } else {
          return [] // 默认不禁用其他分钟
        }
      } else {
        return [] // 默认不禁用其他分钟
      }
    },
    // // 禁用小时
    disabledHours() {
      // 返回需要禁用的小时数组
      return this.hours
    },
    // // 禁用小时
    disabledHour() {
      // 返回需要禁用的小时数组
      return this.hour
    },
    handleChange(e) {
      console.log(e, '12121212')
      this.form.businessDays = e.sort((a, b) => a - b)
    },
    // 禁用分钟
    disabledMinutes(selectedHour) {
      console.log(selectedHour, 'selectedHour')
      if (this.hours && this.hours.length) {
        const index = this.hours.length - 1
        console.log(this.hours[index], ' this.hours[index]')
        if (selectedHour === this.hours[index] + 1) {
          return this.minutes
        } else {
          return [] // 默认不禁用其他分钟
        }
      } else {
        return [] // 默认不禁用其他分钟
      }
    },
    // 点击选择开始时间和结束时间
    handleTime(e, index) {
      // console.log(e.d,index,'1121212');
      const h = moment(e).format('HH')
      const m = moment(e).format('mm')
      console.log(e, '对对对对对对--===')

      const arr = []
      const array = []
      console.log(h, 'hhhhhh')
      console.log(m, 'hhhhhh')

      if (index === 1) {
        this.form.startTime = Number(h) * 60 + Number(m)
        this.form.startTimes = moment(e).format('YYYY-MM-DD HH:mm')
        console.log(this.form.startTimes, 'this.form.startTimesthis.form.startTimes')

        this.$forceUpdate()
        for (let i = 0; i <= Number(h) - 1; i++) {
          // if (i === 6) {
          //   break // 当 i 等于 5 时，退出循环
          // }
          // console.log('当前值:', i)
          arr.push(i)
        }
        this.hours = arr
        console.log(arr, 'ppppp')
        for (let i = 0; i <= Number(m); i++) {
          array.push(i)
        }
        this.minutes = array
      } else {
        this.form.endTime = Number(h) * 60 + Number(m)
        this.form.endTimes = moment(e).format('YYYY-MM-DD HH:mm')
        this.$forceUpdate()
        for (let i = Number(h) + 1; i <= 24; i++) {
          // if (i === 6) {
          //   break // 当 i 等于 5 时，退出循环
          // }
          // console.log('当前值:', i)
          arr.push(i)
        }
        this.hour = arr
        for (let i = Number(m); i <= 59; i++) {
          array.push(i)
        }
        this.minute = array
        console.log(this.minute, 'minuteminuteminute')
      }

      console.log(h, '12121212')
      console.log(m, '12121212mmm')
    },
    submit() {
      this.submitLoading = true
      updateUserProfile(this.user)
        .then((response) => {
          this.$notification.open({
            message: '提示',
            description: '修改成功',
            icon: <a-icon type="check" style="color: #1890FF" />,
            duration: 3,
          })
        })
        .finally(() => {
          this.submitLoading = false
        })
    },
  },
}
</script>
  
  <style lang="less" scoped>
.avatar-upload-wrapper {
  height: 200px;
  width: 100%;
}

.ant-upload-preview {
  position: relative;
  margin: 0 auto;
  width: 100%;
  max-width: 180px;
  border-radius: 50%;
  box-shadow: 0 0 4px #ccc;

  .upload-icon {
    position: absolute;
    top: 0;
    right: 10px;
    font-size: 1.4rem;
    padding: 0.5rem;
    background: rgba(222, 221, 221, 0.7);
    border-radius: 50%;
    border: 1px solid rgba(0, 0, 0, 0.2);
    z-index: 1;
  }
  .mask {
    opacity: 0;
    position: absolute;
    background: rgba(0, 0, 0, 0.4);
    cursor: pointer;
    transition: opacity 0.4s;
    z-index: 1;

    &:hover {
      opacity: 1;
    }

    i {
      font-size: 2rem;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -1rem;
      margin-top: -1rem;
      color: #d6d6d6;
    }
  }

  img,
  .mask {
    width: 100%;
    max-width: 180px;
    height: 100%;
    border-radius: 50%;
    overflow: hidden;
  }
}
.ant-form {
  display: flex;
  flex-wrap: wrap;
  //   height: 10vh;
  .ant-form-item {
    width: 48%;
    &:nth-child(2n + 1) {
      margin-right: 10px;
      margin-left: 10px;
    }
  }
}
.account-settings-info-view {
  width: 100%;
  height: 65vh;
  overflow-y: auto;
  scrollbar-width: thin; /* 或者 'none' 如果你想要完全隐藏滚动条 */
  overflow-x: hidden;
}
</style>
  